import { render, staticRenderFns } from "./ModattaSideModalNewOffer.vue?vue&type=template&id=d3af664e"
import script from "./ModattaSideModalNewOffer.vue?vue&type=script&lang=js"
export * from "./ModattaSideModalNewOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports